module.exports = __webpack_public_path__ + "img/apple-logo.f92d26fc.svg";